import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { selectLoggedInUserDataId, selectProposal } from 'src/app/common/store/state/app.state';
import { Observable } from 'rxjs';
import { BuyActions } from 'src/app/common/store/actions/buy.actions';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { ProposalStatus, ProposalAction } from '../../constants/buy-basic-data';
import { ProposalModif } from '../../models/proposal-modif.model';
import { Proposal } from '../../models/proposal.model';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ObjectData } from 'src/app/public/common/models/object-data.model';

import { MatInputModule } from '@angular/material/input';


@Component({
    selector: 'app-proposal-dialog',
    templateUrl: './proposal-dialog.component.html',
    styleUrls: ['./proposal-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatDialogModule]
})
export class ProposalDialogComponent implements OnInit{

  currentUserId$ : Observable<string>;
  currentUserId: string = "";
    
  proposal$ : Observable<Proposal | undefined>;
  proposal: Proposal = new Proposal();

  isModification: boolean = false;
  isCompletion: boolean = false;

  ProposalStatus = ProposalStatus;
  
  constructor(
    public dialogRef: MatDialogRef<ProposalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObjectData,
    private store: Store,
    private router: Router, 
    private route: ActivatedRoute) {
      this.currentUserId$ = store.select(selectLoggedInUserDataId);
      this.proposal$ = store.select(selectProposal(data.objectSource, data.offerId, data.objectId)); 
    }

    ngOnInit(): void {
      //this.isReschedule = (this.data.rescheduleDate ==='1');
      this.currentUserId$.subscribe(
          (id: string) => this.currentUserId = id
      );
  
      this.proposal$.subscribe(
        (result: Proposal | undefined) => {
          if(result == undefined){
            this.proposal = new Proposal()
            this.proposal.offerId = this.data.offerId;
          }
          else{
            //this.proposal = Object.assign(new Proposal(), result)
            this.proposal = JSON.parse(JSON.stringify(result))
          }
          //this.reply = ""
        }
      );

      this.isCompletion = this.data.objectAction! === ProposalAction.COMPLETE
      this.isModification = this.data.objectAction! === ProposalAction.EDIT_MODIF

      if(this.isModification && this.proposal.modification === null){
        this.proposal.modification = new ProposalModif();
        this.proposal.modification.id = this.proposal.id
      }
    } 
  
    onNoClick(): void {
      this.dialogRef.close();
    }

    submitProposal(){
    
      if(this.proposal.id === 0){
        console.log('new')
        this.store.dispatch(BuyActions.proposalNewSubmit({ proposal: this.proposal, objectSource: this.data.objectSource }));
      }
      else{
        if(this.isModification){
          console.log('modif')
          //this.store.dispatch(BuyActions.proposalRescheduleSubmit ( { proposalId: this.proposal.id, rescDate: this.proposal.rescheduleDate, objectSource: this.data.objectSource }));
          this.store.dispatch(BuyActions.proposalActionSubmit({ proposalAction: ProposalAction.EDIT_MODIF, proposal: this.proposal.modification!, objectSource: this.data.objectSource }));
        }
  
        else{
          console.log('update or complete')
          this.store.dispatch(BuyActions.proposalActionSubmit({ proposalAction: this.data.objectAction as ProposalAction, proposal: this.proposal, objectSource: this.data.objectSource }));         
        } 
      }
      this.dialogRef.close();
    }

    dateFormat(dt: string): string{
    
      return AppFunctions.stringToDatetime(dt);
    }
}


